var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoGroupchatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info_13px",
    transform: "translate(-549.4 -325.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information-circle-outline",
    transform: "translate(549.4 325.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M69.9,63.4a6.5,6.5,0,1,1-6.5,6.5A6.507,6.507,0,0,1,69.9,63.4Zm0,11.9a5.4,5.4,0,1,0-5.4-5.4A5.408,5.408,0,0,0,69.9,75.3Z",
    transform: "translate(-63.4 -63.4)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(5.088 3.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M220.635,223.217a.462.462,0,0,1-.462-.462v-2.432h-.312a.462.462,0,1,1,0-.923h.774a.462.462,0,0,1,.462.462v2.894A.462.462,0,0,1,220.635,223.217Z",
    transform: "translate(-218.954 -217.589)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M209.99,340.323h-2.128a.462.462,0,0,1,0-.923h2.128a.462.462,0,0,1,0,.923Z",
    transform: "translate(-207.4 -334.471)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M222.731,130a.731.731,0,1,0,.731.731A.731.731,0,0,0,222.731,130Z",
    transform: "translate(-221.19 -130)",
    fill: "#0d0d0d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGroupchatIcon);
export default __webpack_public_path__ + "static/media/info-groupchat-icon.220dd527c5241ba5c0dadb7eb6dfb35d.svg";
export { ForwardRef as ReactComponent };